import React, { useContext } from "react";
import { Modal, Heading, Flex, Button, StatusIcon } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../contexts/i18nContext";

export default function UngroupPopup(props) {
  const { t } = useContext(I18nContext);
  const { unGroupPromptVisible, toggleUngroupConfirmation, ungroupSelectedNode } = props;

  return (
    <Modal size="sm" isOpen={unGroupPromptVisible}>
      <Flex direction="vertical" gap={32}>
        <Flex align="center" gap={12}>
          <StatusIcon
            status="warning"
            style={{
              marginTop: -2
            }}
          />
          <Heading as="h2" size="primary">
            {t("hierarchy-nodes.warning-text")}
          </Heading>
        </Flex>
        <Flex justify="center">
          <div>{t("hierarchy-nodes.want-to-ungroup-node-text")}?</div>
        </Flex>
        <Flex justify="flex-end" style={{ width: "100%" }}>
          <Button.Group className="modal-footer">
            <Button kind="tertiary" onClick={toggleUngroupConfirmation}>
              {t("hierarchy-nodes.no-text")}
            </Button>
            <Button destructive onClick={ungroupSelectedNode}>
              {t("hierarchy-nodes.yes-text")}
            </Button>
          </Button.Group>
        </Flex>
      </Flex>
    </Modal>
  );
}
